import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const CSS_BackgroundRepeat = () => {
  return (
    <div className="tutorial-container">
      <h1 className="tutorial-title">🔁 CSS Background Repeat</h1>

      <p className="tutorial-intro">
        The <code>background-repeat</code> property defines how a background
        image repeats (or doesn’t repeat) inside an element. By default, images
        repeat both horizontally and vertically.
      </p>

      {/* Syntax */}
      <div className="tutorial-section">
        <h2 className="section-title">1️⃣ Syntax</h2>
        <CodeCopyBlock
          code={`div {
  background-image: url("pattern.png");
  background-repeat: repeat;   /* default */
}`}
        />
      </div>

      {/* repeat */}
      <div className="tutorial-section">
        <h2 className="section-title">2️⃣ repeat (Default)</h2>
        <p>
          The image repeats both <strong>horizontally and vertically</strong>.
        </p>
        <div
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1503023345310-bd7c1de61c7d?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=60')",
            backgroundRepeat: "repeat",
            backgroundSize: "80px",
            height: "220px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            marginTop: "1rem",
          }}
        ></div>
      </div>

      {/* repeat-x */}
      <div className="tutorial-section">
        <h2 className="section-title">3️⃣ repeat-x</h2>
        <p>
          The image repeats <strong>only horizontally</strong>.
        </p>
        <div
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1503023345310-bd7c1de61c7d?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=60')",

            backgroundSize: "80px",
            height: "220px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            marginTop: "1rem",
          }}
        ></div>
      </div>

      {/* repeat-y */}
      <div className="tutorial-section">
        <h2 className="section-title">4️⃣ repeat-y</h2>
        <p>
          The image repeats <strong>only vertically</strong>.
        </p>
        <div
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1472214103451-9374bd1c798e?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=60')",
            backgroundRepeat: "repeat-y",
            backgroundSize: "80px",
            height: "220px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            marginTop: "1rem",
          }}
        ></div>
      </div>

      {/* no-repeat */}
      <div className="tutorial-section">
        <h2 className="section-title">5️⃣ no-repeat</h2>
        <p>
          The image appears <strong>only once</strong> (no repetition).
        </p>
        <div
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1472214103451-9374bd1c798e?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=60')",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100px",
            backgroundPosition: "center",
            height: "220px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            marginTop: "1rem",
          }}
        ></div>
      </div>

      {/* space */}
      <div className="tutorial-section">
        <h2 className="section-title">6️⃣ space</h2>
        <p>
          Images repeat and are spaced evenly. Extra space is distributed{" "}
          <strong>between images</strong>, not at the edges.
        </p>
        <div
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=60')",
            backgroundRepeat: "space",
            backgroundSize: "60px",
            height: "220px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            marginTop: "1rem",
          }}
        ></div>
      </div>

      {/* round */}
      <div className="tutorial-section">
        <h2 className="section-title">7️⃣ round</h2>
        <p>
          Images are repeated and <strong>scaled</strong> so that they fit the
          container exactly, without cutting off.
        </p>
        <div
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1472214103451-9374bd1c798e?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=60')",
            backgroundRepeat: "round",
            backgroundSize: "80px",
            height: "220px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            marginTop: "1rem",
          }}
        ></div>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">🚀 Next Steps</h2>
        <p>
          The <code>background-repeat</code> property is often combined with{" "}
          <code>background-size</code> and <code>background-position</code> for
          precise control. Next, check out{" "}
          <a href="/css/background-position" className="learn-more">
            CSS Background Position
          </a>{" "}
          to see how to place images exactly where you want them.
        </p>
      </div>
    </div>
  );
};

export default CSS_BackgroundRepeat;
